// Developer: Ankit Gupta
/**
 * Whether the interface reads right to left, re-rendering on a language change.
 *
 * antd mirrors its own components, but a placement a page names itself
 * ('left', 'topLeft', 'right') is taken literally; a component that opens from
 * the start side picks its placement from this.
 */
import { directionOf, useLanguage } from '@/i18n';

export function useIsRtl(): boolean {
  return directionOf(useLanguage()) === 'rtl';
}
